module.exports = __webpack_public_path__ + "img/money.3c20fa11.png";